import type { SxProp } from 'src/types/mui';

export const mainContainerStyles: SxProp = {
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-end',
  height: '100vh',
};

const DRAWER_OPENED_WIDTH = 250;
const DRAWER_CLOSED_WIDTH = 83;

export const menuContainerStyles = (isDrawerOpen: boolean): SxProp => ({
  width: isDrawerOpen ? `${DRAWER_OPENED_WIDTH}px` : `${DRAWER_CLOSED_WIDTH}px`,
  transition: '300ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
  flexShrink: 0,
  height: '100vh',
  whiteSpace: 'nowrap',
  overflowX: 'hidden',
});

export const mobileMenuContainerStyles = (isDrawerOpen: boolean): SxProp => ({
  width: isDrawerOpen ? '100%' : 0,
  transition: '300ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
  flexShrink: 0,
  height: `calc(100% - 96px)`,
  whiteSpace: 'nowrap',
  overflowX: 'hidden',
});

export const contentWrapperStyles = (isDrawerOpen: boolean, isResponsive?: boolean): SxProp => ({
  flexGrow: 1,
  // eslint-disable-next-line no-nested-ternary
  maxWidth: isResponsive
    ? '100%'
    : isDrawerOpen
      ? `calc(100% - ${DRAWER_OPENED_WIDTH}px)`
      : `calc(100% - ${DRAWER_CLOSED_WIDTH}px)`,
  transition: '300ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
});

export const appContainerStyles = (isDrawerOpen: boolean): SxProp => ({
  flexGrow: 1,
  maxWidth: isDrawerOpen
    ? `calc(100% - ${DRAWER_OPENED_WIDTH}px)`
    : `calc(100% - ${DRAWER_CLOSED_WIDTH}px)`,
  transition: '300ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 0',
  height: '100%',
});

export const mobileAppContainerStyles: SxProp = {
  flexGrow: 1,
  width: '100%',
  transition: '300ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 0',
  height: '100%',
};

export const appContentWrapperStyles =
  (isExactHomePath: boolean): SxProp =>
  theme => ({
    height: '100%',
    backgroundColor: '#FFF',
    flex: '0 1 auto',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      padding: !isExactHomePath ? 0 : 2,
      backgroundColor: !isExactHomePath ? '#FFF' : 'slate.50',
      overflow: 'auto',
    },
  });

export const mobileDrawerHeaderStyles: SxProp = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: 2,
};

export const avatarStyles: SxProp = {
  width: '64px',
  height: '64px',
};

export const logoStyles: SxProp = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1,
};
